import { createFormStageContext } from 'BreetHelpers';

import { type RATECALCULATORTYPE } from '../DialogRateCalculator.helpers';

export const { ContextComponent: RateCalculatorFormStageContext, useFormStageContext: useRateCalculatorFormStageContext } =
	createFormStageContext<RATECALCULATORTYPE>();
